import ClearPannel from './Todo-clear-pannel';

export default ClearPannel;